import React from 'react';

import { Icon, Popconfirm, Tooltip } from 'antd';
import styled from 'styled-components';

import { BUSINESS_LOGIC_TAB } from '../../containers/ComplexDocumentDesign/translationValues';
import { dummyCallback } from '../../utils/complexDocumentConstants';

const TagWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #dcdcdc;
  color: #333;
  border-radius: 20px;
  padding: 5px 10px;
  margin: 5px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #ccc;
  &:hover {
    background-color: #cdcdcd;
  }

  .removeIcon {
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: color 0.2s ease;

    &:hover {
      color: red;
    }
  }
`;

const TagName = styled.span`
  margin-right: 6px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
`;

const LabelTag = ({
  tagInfo,
  onRemove = dummyCallback,
  popConfirmTitle,
  handleTagClick = dummyCallback,
  t,
  isInteractiveDesign = false,
}) => {
  return (
    <TagWrapper>
      <TagName
        onClick={() => {
          handleTagClick(tagInfo);
        }}
      >
        {tagInfo.groupName.length > 30 ?
          <Tooltip
            placement="top"
            title={tagInfo.groupName}
          >
            {tagInfo.groupName.substring(0,30) + '...'}
          </Tooltip>
        : tagInfo.groupName  
        }
      </TagName>
      {isInteractiveDesign ? null : (
        <Popconfirm
          title={popConfirmTitle}
          okText={t(BUSINESS_LOGIC_TAB.BL_CONFIRM_YES.key, BUSINESS_LOGIC_TAB.BL_CONFIRM_YES.value)}
          cancelText={t(
            BUSINESS_LOGIC_TAB.BL_CONFIRM_NO.key,
            BUSINESS_LOGIC_TAB.BL_CONFIRM_NO.value,
          )}
          onConfirm={() => onRemove(tagInfo.groupId)}
        >
          {' '}
          <Icon type="delete" className="removeIcon" />
        </Popconfirm>
      )}
    </TagWrapper>
  );
};

export default LabelTag;
